import { Feather } from '@expo/vector-icons';
import { useNavigation } from '@react-navigation/native';
import React from 'react';
import { Dimensions, Linking, Text, TouchableOpacity, useWindowDimensions, View } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';

const About = () => {

    const { goBack } = useNavigation();
    
    return (
        <SafeAreaView
            style={{
                alignItems: 'center',
                flex: 1,
                width: '100%'
            }} 
        >
            <View style={{
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'space-between',
                marginTop: 30,
                width: "90%",
                marginLeft: 'auto',
                marginRight: 'auto',
                marginBottom: 30
            }}>
                <TouchableOpacity
                    onPress={() => goBack()} 
                >
                    <Feather name="arrow-left" size={28} />
                </TouchableOpacity>
            </View>
            <View
                style={{
                    width: (useWindowDimensions().width < 500 ? '100%' : 500)
                }} 
            >
                <Text style={{
                    fontSize: 28,
                    fontFamily: 'Montserrat_500Medium',
                    textAlign: 'center'
                }}>Sobre o app{'\n'}</Text>
                <Text
                    style={{
                        fontSize: 24,
                        fontFamily: 'Montserrat_400Regular',
                        marginLeft: 20
                        // textAlign: 'center'
                    }} 
                >
                    O app tem como objetivo facilitar a experiência de leitura do Catecismo da Igreja Católica em dispositivos móveis. {'\n\n'}
                    O aplicativo funciona offline e todo o conteúdo apresentado é uma cópia do que está no site do Vaticano, disponível em: {'\n'}
                    <Text
                        onPress={() => Linking.openURL('https://www.vatican.va/archive/cathechism_po/index_new/prima-pagina-cic_po.html')} 
                        style={{
                            color: '#32A9F0'
                        }}
                    >
                        https://www.vatican.va/archive/cathechism_po/index_new/prima-pagina-cic_po.html {'\n\n'}
                    </Text>
                    Salve Maria Imaculada!
                </Text>
            </View>
        </SafeAreaView>
    );
};

export default About;